import Link from '~/core/Link'

type EditLinkPropsType = {
    className?: string
    field?: string
    handleSelectEdit?: (selectedField: string) => void
}

export default function EditLink(props: EditLinkPropsType) {
    const { className, field, handleSelectEdit } = props

    return (
        <Link
            className={className}
            name="edit"
            data-test-target={`user-profile-edit${field ? '-' : ''}${
                field || ''
            }`}
            placement="user-profile"
            to={null}
            onClick={(evt: Event) => {
                evt.preventDefault()
                if (field && handleSelectEdit) {
                    handleSelectEdit(field)
                }
            }}
            style={{ marginLeft: 'auto' }}
        >
            Edit
        </Link>
    )
}
